module.exports = __webpack_public_path__ + "img/WhiskyGlenmorangie10anos.cf46da5e.jpg";